var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-input',_vm._b({attrs:{"value":_vm.value,"addon-after":_vm.addon,"autocomplete":"off","allow-clear":""},on:{"blur":_vm.onBlur,"change":_vm.onChange,"input":_vm.onInput,"keypress":_vm.numberOnly}},'a-input',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }